// import jwtService from 'app/services/jwtService';
import {socket} from 'context/socket';
import axios from 'axios';
import * as HELPER from 'context/helper'

export const GET_USER_DATA = '[USER CONNECTED] GET USER DATA';
export const GET_USER_DATA_ERROR = '[USER CONNECTED] GET USER DATA ERROR';
export const SET_CURRENT_USER_DATA = '[USER] SET CURRENT USER DATA';
export const UPDATE_AVATAR = '[CHAT APP] UPDATE AVATAR';
export const GET_USER_CONN_DATA = '[USER] GET USER CONN DATA';
export const UPDATE_USER_STATUS = '[USER] UPDATE USER STATUS';


export const updateUserStatus = (data) => dispatch => {
  console.log("updateUserStatus => ", data)
  return dispatch({
    type: UPDATE_USER_STATUS,
    status: data,
  })
}

export const getUserConnectedData = () => async dispatch => {
console.log("getUserConnectedData1")
  let current_user = JSON.parse(localStorage.getItem('current_user'));
	let token = current_user['authToken'];
  const request = axios.get(process.env.REACT_APP_SERVER + '/api/profile/get-logged-user-info', {
    headers: { Authorization: `Token ${token}` }
  });

  return request.then(response => {
    if (response.data) {
      return dispatch({
        type: GET_USER_CONN_DATA,
        data: response.data,
      });
    } else {
      //reject(response.data.error);
    }
});

};

export const setCurrentUser = (data) => dispatch => {
  return dispatch({
    type: SET_CURRENT_USER_DATA,
    payload: data.userDetails,
  })
}

export const getUserData = () => {
  var data = {};
  if(localStorage.getItem('current_user')) {
    data = JSON.parse(localStorage.getItem('current_user'));
  }
  return {
    type: GET_USER_DATA,
    payload: data,
  }    
};


export function changeUserImgBucket(data) {
		let current_user = JSON.parse(localStorage.getItem('current_user'));
		let token = current_user['authToken'];;

	return (dispatch, getState) => {

    const config = {
      headers: { 'X-CSRFToken': `Token ${token}` }
    };
    /*const bodyParameters = {
      type: 'POST',
      dataType: 'json',
      data: data,
      cache : false,
      contentType: false,
      processData: false,
    };*/
    const request = axios.post(process.env.REACT_APP_BUCKET + 'change-user-img-bucket', 
                                data,
                                config                      
    );

		return request.then(response => {
      if (response.data['isError']==='false'){
        let _imUrl = response.data['location']
        socket.emit("update_pro_img", {userId: current_user.id, profileImg: _imUrl,authToken: HELPER.getAuthToken()})
      }
      else if (response['isError']==='true'){
        console.log("S3 Bucket Error: ",)
        //hidePageLoader()
        // notifyError("File Error", "Please select an JPG/JPEG/PNG image")
       // notifyError(langTrans.notifyErr, langTrans.notifyS3Err)
      }
			return dispatch({
				type: UPDATE_AVATAR,
				avatar: response.data,
			});
		});
	};
}